import React from "react";
import Header from "../Layout/Header";
import Abouthome from "../Content/Abouthome";
import Footer from "../Layout/Footer";
import Donate from "../Content/Donate";
import GivingOpportunities from "../Content/GivingOpportunities";
import WaysToGiveContent from "../Content/WaysToGiveContent";
import SliderNew from "../Layout/SliderNew";
import DonationUpdateContent from "../Content/DonationUpdateContent";

function Home() {
    return (
        <div>            
            <div className='main-content'>
                <Header />
                <SliderNew/>
                <Abouthome />                
                <GivingOpportunities/>  
                <WaysToGiveContent/>   
                <Donate/>      
                <DonationUpdateContent/>  
            </div>
            <Footer />
        </div>
    );
}

export default Home;